import { h } from 'preact';
import $ from 'jquery';
import MenuObject from '../canvas/menu-object';
import store from '../store';
import * as actions from '../actions';
import CloseIcon from './svg/CloseIcon';
import {
  isClover,
  isMHM,
  isSquareGroup,
  isTreezGroup,
  isPopmenuGroup,
  isToast,
  syncToSquare,
  updateMenuGroup,
  isItemLibraryGroup
} from '../service/menuGroupService';
import {
  setMenuGroups,
  setMenuGroupsSourceInProgress,
  setPosAutoSyncEnabled,
  setPosSyncPendingCount,
  setSquareLoading,
  setSquareSelect
} from '../actions';
import util, {saveDesign} from '../util';
import { useEffect, useState } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import posService from '../service/posService';
import { syncInGroup, updateMenuGroupContent } from '../canvas/menu-group';
import Renderer from '../canvas/renderer';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import ToastIcon from './icon/ToastIcon';
import constants from '../constants';
import Spinner from './Spinner';
import SquareIcon from './icon/SquareIcon';
import MOImportIcon from './svg/MOImportIcon';
import { Switch } from 'antd';
import designService from '../service/designService';
import TreezIcon from "./icon/TreezIcon";
import PopmenuIcon from "./icon/PopmenuIcon";
import ItemLibraryIcon from "./icon/ItemLibraryIcon";
import {getItemLibraryProps} from "../service/dataLibraryService";
import ItemLibraryIconInverted from "./icon/ItemLibraryIconInverted";

export let isMenuItemDataImportMode = false;

function cleanPlaceholders() {
  let $placeholders = $('.menu-object-placeholder');
  $placeholders.off();
  $placeholders.remove();

  $placeholders = $('.page-menu-object-placeholder');
  $placeholders.off();
  $placeholders.remove();

  $('.menu-object')
    .removeClass('placeholder-mode');
}

export let MENU_GROUP_IN_PROGRESS = false;
export default function MenuItemDataImport({
                                             designId,
                                             memberId,
                                             menuGroups,
                                             menuGroupsSource,
                                             menuGroupsSourceInProgress,
                                             isSquare,
                                             isTreez,
                                             isPopmenu,
                                             toastEmail,
                                             addMenuItem,
                                             isMobileVersion,
                                             posAutoSyncEnabled,
                                             posSyncPendingCount,
                                             isFreemium,
                                             hasPosData,
                                             hasPdfPermission,
                                             setActiveMember
                                           }) {
  const [activeGroup, setActiveGroup] = useState(null);
  const [hasToastSource, setToastSource] = useState(false);
  const [hasSquareSource, setSquareSource] = useState(false);
  const [hasCloverSource, setCloverSource] = useState(false);
  const [hasTreezSource, setTreezSource] = useState(false);
  const [hasPopmenuSource, setPopmenuSource] = useState(false);
  const [showPosBanner, setShowPosBanner] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);

  useEffect(() => {
    setToastSource(!!menuGroups.length && menuGroupsSource.toLowerCase() === 'toast');
    setSquareSource(!!menuGroups.length && menuGroupsSource.toLowerCase() === 'square');
    setCloverSource(!!menuGroups.length && menuGroupsSource.toLowerCase() === 'clover');
    setTreezSource(!!menuGroups.length && menuGroupsSource.toLowerCase() === 'treez');
    setPopmenuSource(!!menuGroups.length && menuGroupsSource.toLowerCase() === 'popmenu');
  }, [menuGroupsSource, menuGroups]);

  function stopWorkFlow() {
    store.dispatch(setMenuGroupsSourceInProgress(false));
    MENU_GROUP_IN_PROGRESS = false;
    isMenuItemDataImportMode = false;
    cleanPlaceholders();

    const groups = [...menuGroups];
    groups.forEach(it => it.selected = false);
    store.dispatch(setMenuGroups(groups));

    setTimeout(saveDesign, 500);
  }

  function syncMenuGroups(data, callback) {
    util.nextTick(() => {
      updateMenuGroup({
        designId,
        memberId,
        source: menuGroupsSource,
        data: JSON.stringify(data)
      })
        .then(() => {
          if (typeof callback === 'function') {
            callback();
          }
        });
    });
  }

  function removeGroup(ev, group) {
    ev.stopPropagation();

    canDeleteMenu([group]).then(resp => {
      if (resp) {
        setActiveGroup(group);
        confirmRemoveGroup(null, group);
      } else {
        window.ItemLibrary.ILAlert.showError({text: 'Menu items in use. Delete unavailable.'});
      }
    })
  }

  function confirmRemoveGroup(ev, group = null) {
    const groupToRemoveId = group ? group.id : activeGroup.id;
    const updated = menuGroups.filter(it => it.id !== groupToRemoveId);
    store.dispatch(setMenuGroups(updated));

    syncMenuGroups(updated);
    setActiveGroup(null);
  }

  function canDeleteMenu(groups) {
    return new Promise((resolve) => {
      const menuId = groups[0].menuId;
      const id = groups[0].id;
      const source = groups[0].source;

      if (source === 'mhm') {
        if (!document.querySelectorAll(`*[data-source="mhm"][data-id="${id}"]`).length) {
          return resolve(true);
        } else {
          return resolve(false);
        }
      }

      if (!document.querySelectorAll(`*[data-menuid="${menuId}"]`).length) {
        return resolve(true);
      }

      if (groups.length === 1) {
        return resolve(!document.querySelectorAll(`*[data-id="${id}"]`).length);
      } else {
        window.ItemLibrary.Lib.validateItemDeletion(menuId).then((resp) => {
          return resolve(!resp.usedInDesigns.includes(window.data.design.id));
        }).catch(() => resolve(false));
      }
    });
  }

  function removeGroups(ev, groups) {
    ev.stopPropagation();
    if (!groups || !groups.length) return;

    canDeleteMenu(groups).then(resp => {
      if (resp) {
        const groupIdsToRemove = groups.map(it => it.id);
        const updated = menuGroups.filter(it => !groupIdsToRemove.includes(it.id));
        store.dispatch(setMenuGroups(updated));

        syncMenuGroups(updated);
        setActiveGroup(null);
      } else {
        window.ItemLibrary.ILAlert.showError({text: 'Menu items in use. Delete unavailable.'});
      }
    });
  }

  function replaceMenuGroup($mo, group, menuGroupsSource, groups, skipSync) {
    updateMenuGroupContent($mo, group, menuGroupsSource);
    group.added = true;
    store.dispatch(setMenuGroups([...groups]));

    if (!skipSync) {
      syncMenuGroups(groups);
    }
  }

  function onGroupClick(ev, group) {
    ev.stopPropagation();
    isMenuItemDataImportMode = true;

    const groups = [...menuGroups];
    groups.forEach(it => it.selected = it.id === group.id);
    groups.selected = true;
    store.dispatch(setMenuGroups(groups));

    store.dispatch(setMenuGroupsSourceInProgress(true));
    MENU_GROUP_IN_PROGRESS = true;

    if (isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(true));
    }

    cleanPlaceholders();
    $('.menu-object')
      .append('<div class=\'menu-object-placeholder\'></div>');
    $('.page > .content')
      .prepend('<div class=\'page-menu-object-placeholder\'></div>');
    $('.menu-object')
      .addClass('placeholder-mode');

    $('.menu-object-placeholder')
      .on('click', function (ev) {
        ev.stopPropagation();
        const $overlay = $(this);
        const $mo = $overlay.parent();

        replaceMenuGroup($mo, group, menuGroupsSource, groups);

        $overlay.remove();
        util.nextTick(() => {
          $('.mo-options')
            .hide();
        });

        stopWorkFlow();
      });

    $('.page-menu-object-placeholder')
      .on('click', function (ev) {
        ev.stopPropagation();
        const $this = $(this);
        const {
          clientX,
          clientY
        } = ev;
        const {
          top,
          left
        } = $this.offset();
        const positionTop = $this.position().top;
        const $window = $(window);

        const items = [
          new MenuObject.MenuObjectName('Group Name'),
          new MenuObject.MenuItem('Item Name', '', 'Write a description that makes the ordinary sound extraordinary.', [{
            size: '',
            price: '$'
          }], '', '', '', [], [], '', '')
        ];

        console.table({
          window: $window.scrollTop(),
          page: top,
          click: clientY
        });

        const style = JSON.parse(MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE);
        const id = MenuObject.addMenuItemsTemplateToCanvas(style.layout, items, {
          position: {
            left: clientX - left,
            top: clientY - top + (window.scrollY > top ? positionTop : window.scrollY),
          },
          isFromTemplate: true,
          keepColors: true
        });

        util.nextTick(() => {
          updateMenuGroupContent($(`#${id}`), group, menuGroupsSource);
        });

        stopWorkFlow();
      });
  }

  function onImportItemsClick() {
    store.dispatch(actions.setIsDataLibraryModal(true));
  }

  function onItemLibraryClick() {
    if (!hasPdfPermission) {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: setActiveMember });
      return;
    }
    window.ItemLibrary.Lib.show({
      ...getItemLibraryProps(),
      onImportBtnClicked: (menus) => {
        window.ItemLibrary.Lib.hide();
        store.dispatch(actions.setIsDataLibraryModal(true));
        document.dispatchEvent(new Event("goToItemLibraryView"));
      },
      onAddToDesign: (menus) => {
        window.ItemLibrary.Lib.hide();
        store.dispatch(actions.setIsDataLibraryModal(true));
        document.dispatchEvent(new CustomEvent("goToItemLibraryViewWithMenus", {detail: {menus}}));
      }
    });
  }

  function closePosBanner() {
    setShowPosBanner(false);
    setIntegrationBannerShownCookie();
    window.data.props.isShowPosBanner = false;
  }

  function getIcon(menuGroup) {
    if (isMHM(menuGroup)) {
      return null;
    }
    if (isToast(menuGroup)) {
      return <ToastIcon/>;
    }
    if (isClover(menuGroup)) {
      //return <CloverIcon/>;
    }
    if (isSquareGroup(menuGroup)) {
      return <SquareIcon/>;
    }
    if (isTreezGroup(menuGroup)) {
      return <TreezIcon/>
    }
    if (isPopmenuGroup(menuGroup)) {
      return <PopmenuIcon/>
    }
    if (isItemLibraryGroup(menuGroup)) {
      return <ItemLibraryIconInverted/>
    }
    return null;
  }

  async function triggerSyncToSquare(selectedMenuGroups, callback) {
    if (!menuGroups.length || !selectedMenuGroups.length) return;

    selectedMenuGroups.forEach(mgId => {
      if (MenuObject.isGroupOnCanvas(mgId)) {
        console.log(`=> mgId ${mgId} is on canvas`);
        syncInGroup(MenuObject.getMenuGroup(mgId), store.getState().menuGroups);
      } else {
        console.log(`=> mgId ${mgId} is NOT on canvas`);
      }
    });

    syncMenuGroups(menuGroups, async () => {
      console.log('=> syncing to square', menuGroups);

      const restaurants = (await posService.getSquareRestaurants()).data;
      const restaurant = restaurants[0];
      const body = selectedMenuGroups;
      await syncToSquare(restaurant.merchantId, designId, body);

      const res = (await posService.getSquareMenus(restaurant.merchantId)).data;
      const mapped = [posService.mapMenu(res, constants.IMPORT_SOURCE_SQUARE, restaurant.name)];

      let copy = [...menuGroups];
      const mgsToReplace = [];
      selectedMenuGroups.forEach(mgId => {
        const menuGroup = copy.find(it => it.id === mgId);
        const newMG = mapped[0].sections.find(it => (it.name === menuGroup.name || it.id === menuGroup.id));

        if (newMG) {
          let newMenuGroups = copy.filter(o => o.name !== newMG.name);
          if (newMenuGroups.length === copy.length) {
            newMenuGroups = copy.filter(o => o.id !== newMG.id);
          }
          newMG.source = constants.IMPORT_SOURCE_SQUARE;
          newMG.name = menuGroup.name;

          menuGroup.items.forEach(oldItem => {
            const newItem = newMG.items.find(it => it.id === oldItem.id);

            if (newItem) {
              newItem.extras = oldItem.extras;
              newItem.icons = oldItem.icons;
              newItem.prices = oldItem.prices;
            }
          });

          newMenuGroups.push(newMG);

          copy = newMenuGroups;

          mgsToReplace.push({
            mgId,
            newMG
          });
        }
      });

      mgsToReplace.forEach(e => {
        const mgId = e.mgId;
        const newMG = e.newMG;
        if (MenuObject.isGroupOnCanvas(mgId)) {
          replaceMenuGroup(MenuObject.getMenuGroup(mgId), newMG, 'square', copy, false);
        }
      });

      syncMenuGroups(copy);

      if (typeof callback === 'function') callback();
    });
  }

  function onSelectGroup(group) {
    if (selectedGroups.includes(group.id)) {
      setSelectedGroups(old => old.filter(it => it !== group.id));
    } else {
      setSelectedGroups(old => [...old, group.id]);
    }
  }

  async function onSyncEnd() {
    if (!selectedGroups.length) {
      store.dispatch(setSquareSelect(false));
      return;
    }

    store.dispatch(setSquareLoading(true));
    await triggerSyncToSquare(selectedGroups, () => {
      setSelectedGroups([]);
      store.dispatch(setSquareLoading(false));
      store.dispatch(setSquareSelect(false));
    });
  }

  function sortMenuGroups(menuGroups) {
    const mhmGroupsTitled = menuGroups.filter(it => isMHM(it) && !it.isInferredTitle);
    const mhmGroupsTitleInferred = menuGroups.filter(it => isMHM(it) && it.isInferredTitle);
    const toastGroups = menuGroups.filter(it => isToast(it));
    const cloverGroups = menuGroups.filter(it => isClover(it));
    const squareGroups = menuGroups.filter(it => isSquareGroup(it));
    const treezGroups = menuGroups.filter(it => isTreezGroup(it));
    const popmenuGroups = menuGroups.filter(it => isPopmenuGroup(it));
    const itemLibraryGroups = menuGroups.filter(it => isItemLibraryGroup(it));

    const sortByName = (a, b) => a.name.localeCompare(b.name);

    return [...squareGroups.sort(sortByName),
      ...cloverGroups.sort(sortByName),
      ...toastGroups.sort(sortByName),
      ...treezGroups.sort(sortByName),
      ...popmenuGroups.sort(sortByName),
      ...itemLibraryGroups.sort(sortByName),
      ...mhmGroupsTitled.sort(sortByName),
      ...mhmGroupsTitleInferred.sort(sortByName)];
  }

  useEffect(() => {
    if (showIntegrationBanner()) {
      setShowPosBanner(true);
      window.data.props.isShowPosBanner = true;
    }
  }, []);

  function setIntegrationBannerShownCookie() {
    const memberId = window.data.member.id;
    let shownIds = util.getCookie('integration-banner-shown');
    if (!shownIds.includes(memberId)) {
      const now = new Date();
      now.setTime(now.getTime() + 365 * 24 * 60 * 60 * 1000);
      const expiration = 'expires=' + now.toUTCString();
      document.cookie = `integration-banner-shown=${shownIds},${memberId};${expiration};path=/`;
    }
  }

  function showIntegrationBanner() {
    const cookie = util.getCookie('integration-banner-shown');
    return !cookie || !cookie.includes(window.data.member.id);
  }

  function forcePOSSync() {
    designService.syncPOS(designId).then(() => {
      window.ignoreBeforeUnloadWarning = true;
      window.forcedExit = true;
      window.location.reload();
    });
  }

  return <div id="aside-menu-object-import">
    {!isSquare && !isTreez && !isPopmenu && !toastEmail && (showPosBanner || window.data.props.isShowPosBanner) && <div className="pos-banner">
      <div className="text">
        <span className={'header'}>
          Get auto-updates from
        </span>
        <div className="integrated-logos">
          <a href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029141-transfer-menu-data-from-toast" target="_blank">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/ToastWordmark.svg"/>
          </a>
          <div class="logo-sep"/>
          <a href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029503-transfer-menu-data-from-square" target="_blank">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/SquareWordmark.svg"/>
          </a>
        </div>
      </div>
      <div class="close-banner" onClick={() => closePosBanner()}><CloseOutlined/></div>
    </div>}

    <div
      className={`buttons import-button ${!isSquare && !isTreez && !isPopmenu && !toastEmail && (showPosBanner || window.data.props.isShowPosBanner) ? '' : 'no-pos-banner'}`}>
      <a className={'btn primary medium full import'} onClick={() => onImportItemsClick()}><MOImportIcon/> Import Items</a>
    </div>

    <header className={(menuGroupsSourceInProgress || isMobileVersion ? 'in-progress' : '') + ' mmg'}>
      <div className={`one`} style={{ display: (menuGroups.length === 0 ? 'block' : 'flex') }}>
        <div className="title">
          <h3 id="mmg-aside-title">My Menu Groups</h3>
          <div className="open-tour-btn" onClick={() => store.dispatch(actions.setIsMMGTourModal(true))}><QuestionCircleOutlined/></div>
        </div>
      </div>

      <p className="click-anywhere" style={{ display: menuGroupsSourceInProgress && !isMobileVersion ? 'block' : 'none' }}>
        Click anywhere in your design to add
      </p>

      {isMobileVersion && <p className="click-anywhere">Select a group & click anywhere in your design to add</p>}
    </header>

    <ul className={store.getState().squareSelect ? 'square-select' : ''}>
      {Object.entries(
        menuGroups.reduce((acc, group) => {
          let groupName = group.menuName;
          if (groupName === 'undefined') groupName = '';
          groupName = groupName || 'Default Menu';
          (acc[groupName] = acc[groupName] || []).push(group);
          return acc;
        }, {})
      ).sort(([, groupsA], [, groupsB]) => {
         return (groupsA[0].importedDate || 0) - (groupsB[0].importedDate || 0);
        }
      ).map(([menuName, groups]) => (
        <ul key={menuName}>
          {!!menuName && menuName !== 'Default Menu' && <li className="group-title">
            <span className="close" onClick={(ev) => removeGroups(ev, groups)}><CloseIcon /></span>
            <span className="text">{menuName}</span>
          </li>}
          {sortMenuGroups(groups).map(group => (
            <li key={group.name} className={group.isInferredTitle ? 'italicize' : ''}>
              <button className={group.selected ? 'sel' : ''} onClick={(ev) => onGroupClick(ev, group)}>
                <span className="close" onClick={(ev) => removeGroup(ev, group)}><CloseIcon /></span>
                <p>{getIcon(group)}<span>{group.name || 'Group Name'}</span></p>
              </button>
            </li>
          ))}
        </ul>
      ))}
    </ul>

    <div className={`buttons import-button`}>
      <a className={'btn secondary1 medium full import old'} onClick={() => onItemLibraryClick()}><ItemLibraryIcon/> Item Library</a>
    </div>

    {/*{isSquare && !store.getState().squareSelect && !!menuGroups?.length && <button className={'btn primary square-btn'} onClick={() => store.dispatch(setSquareSelect(true))}>Sync to Square</button>}*/}
    {isSquare && store.getState().squareSelect && !store.getState().squareLoading &&
      <button className={'btn primary square-btn'} onClick={onSyncEnd}>Done</button>}
    {isSquare && store.getState().squareSelect && store.getState().squareLoading && <Spinner/>}

    {/*isRemoveModal && createPortal(<div>
      <div className="modal-back" onClick={() => setRemoveModal(false)}></div>
      <div className="modal">
        <header>
          <h2>Are you sure?</h2>
        </header>
        <div className="content">
          <p>
            Removing a group will also remove it from your design.
          </p>
          <footer>
            <a className="btn decline" onClick={() => setRemoveModal(false)}>Cancel</a>
            <a className="btn primary accept" onClick={(ev) => confirmRemoveGroup(ev)}>Remove</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) */}
  </div>;
}
